import type { JobModule } from "./job-module.type";
import type { ApiPayloadList } from "@/services/api";

import { useQueryClient } from "@tanstack/react-query";

import { INTERVENTION_JOB_MODULES_MODEL_KEYS } from "./job-module.constant";

export const useUpdateJobModuleStateQueryData = () => {
  const queryClient = useQueryClient();

  const updateJobModuleState = (
    jobModuleId: number,
    newState: JobModule["state"]
  ) => {
    queryClient.setQueriesData<ApiPayloadList<JobModule>>(
      { queryKey: [INTERVENTION_JOB_MODULES_MODEL_KEYS.LIST, "list"] },
      (oldData) => {
        if (!oldData) return oldData;

        const newData = oldData.data.map((jobModule) =>
          jobModule.id !== jobModuleId
            ? jobModule
            : { ...jobModule, state: newState }
        );

        return { ...oldData, data: newData };
      }
    );
  };

  const invalidateJobModuleList = () => {
    queryClient.invalidateQueries({
      queryKey: [INTERVENTION_JOB_MODULES_MODEL_KEYS.LIST, "list"],
    });
  };

  return {
    updateJobModuleState,
    invalidateJobModuleList,
  };
};
